import React from 'react';

const ValueSection = () => {
  return (
    <section className="py-24 px-6 bg-[#050B15] text-white text-center">
      <div className="max-w-[800px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-10">Built for scrutiny, not screenshots.</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mb-16">
          <div className="flex gap-4">
            <span className="material-symbols-outlined text-[#22C55E]">verified_user</span>
            <p className="text-gray-300"><span className="text-white font-bold">Reduce back-and-forth:</span> Stop the endless audit cycles of data requests and clarifications.</p>
          </div>
          <div className="flex gap-4">
            <span className="material-symbols-outlined text-[#FFD100]">speed</span>
            <p className="text-gray-300"><span className="text-white font-bold">Cut time:</span> Reduce manual collation work by up to 80% with structured evidence management.</p>
          </div>
          <div className="flex gap-4">
            <span className="material-symbols-outlined text-[#F87171]">security</span>
            <p className="text-gray-300"><span className="text-white font-bold">Prepare confidently:</span> Know exactly where your gaps are before they are identified by external third parties.</p>
          </div>
          <div className="flex gap-4">
            <span className="material-symbols-outlined text-[#0077C8]">shield</span>
            <p className="text-gray-300"><span className="text-white font-bold">Protect CFOs:</span> Provide the defensible paper trail needed to sign off on effectiveness with peace of mind.</p>
          </div>
        </div>
        <p className="text-2xl font-bold text-[#22C55E] leading-relaxed max-w-[600px] mx-auto">
          "This is not about dashboards. It's about defensible assurance."
        </p>
      </div>
    </section>
  );
};

export default ValueSection;
